<template>
    <div class="p-6 text-center border-b border-grey-200 rounded sm:text-left high-contrast:border-yellow-300">
        <div class="grid grid-cols-1 gap-4 sm:grid-cols-4 lg:grid-cols-8 lg:items-center">
            <a class="block" :href="item.url">
                <img v-if="item.img_url" class="max-w-full rounded-lg" :src="item.img_url" />
            </a>
            <div class="sm:col-span-3 md:pl-6">
                <a class="text-2xl font-bold font-secondary" :href="item.url">
                    {{ item.name }}
                    <span v-if="item.type" class="block text-sm text-orange leading-none high-contrast:text-yellow-300/75 mb-2">
                        {{ item.type }}
                    </span>
                </a>
                <p class="text-base text-grey-200 high-contrast:text-yellow-300/75" v-if="item.details">
                    {{ item.details }}
                </p>
                <a class="block mt-3 text-base text-orange"
                    href="javascript:;"
                    @click="removeFromCart()"
                >
                    {{ __('Usuń z koszyka') }}
                </a>
            </div>
            <div>
                <span class="block mb-2 text-base sm:mt-3 lg:hidden"> {{ __('Cena jednostkowa') }}: </span>
                <span class="items-center text-2xl md:h-11 md:flex font-secondary lg:text-lg">{{ item.price | price }}</span>
            </div>
            <div class="sm:col-span-2 md:pl-6 lg:pl-0">
                <span class="block mb-2 text-base sm:mt-3 lg:hidden"> {{ __('Liczba sztuk') }}: </span>

                <div class="cart__quantity-group md:ml-0">
                    <div class="flex items-center justify-center sm:justify-start input-group text-1375xl">
                        <span class="pr-2 input-group-btn">
                            <a
                                href="javascript:;"
                                type="button"
                                :class="[
                                    'btn btn-default btn-decrement text-3xl appearance-none',
                                    { disabled: cartItemQuantity <= 1 },
                                ]"
                                @click="decrementQuantity"
                            >
                                <span class="minus"> − </span>
                            </a>
                        </span>
                        <span class="flex items-center justify-center border cart__quantity border-grey-200 w-11 h-11 high-contrast:border-yellow-300"  :class="{ 'border-orange' : !isErrorEmpty }">
                            <strong>{{ cartItemQuantity }}</strong>
                        </span>
                        <span class="pl-2 input-group-btn">
                            <a
                                href="javascript:;"
                                type="button"
                                class="text-3xl btn btn-default btn-increment appearance-none"
                                @click="incrementQuantity"
                            >
                                +
                            </a>
                        </span>
                    </div>
                </div>
            </div>
            <div>
                <span class="block mt-5 mb-2 text-base sm:mt-3 lg:hidden">{{ __('W sumie') }}: </span>
                <span class="items-center text-2xl font-bold md:h-11 md:flex font-secondary">{{ item.total_price | price }}</span>
                <span class="block text-sm font-light text-grey-200 sm:absolute" v-if="item.service_costs_price && item.service_costs_price > 0">
                    {{ __('Koszty serwisowe') }}: {{ item.service_costs_price | price }}
                </span>
            </div>
        </div>
        <span :class="isErrorEmpty ? 'hidden' : 'block'" class="w-full mt-6 text-sm text-right text-orange"><warning class="inline w-4 mr-2 fill-orange"></warning>{{ itemError[0] }}</span>
    </div>
</template>
<script>
import Warning from '@/front/components/Icons/Warning';

export default {
    components: {
        Warning
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            default: 0
        },
        itemError: {
            itemError: Object,
            required: false,
        }
    },
    data() {
        return {
            cartItemQuantity: this.item.quantity,
            maxItemQuantity: this.item.stock_quantity
        };
    },
    computed:{
        isErrorEmpty(){
            return Object.keys(this.itemError).length == 0;
        }
    },
    methods: {
        decrementQuantity() {
            if (this.cartItemQuantity == 1) {
                return;
            }

            this.cartItemQuantity -= 1;
            this.removeFromCartEvent(1);
        },
        incrementQuantity() {
            if (this.cartItemQuantity == this.maxItemQuantity) {
                this.$emit('show-message', "Posiadasz maksymalną ilość");

                return;
            }

            this.cartItemQuantity += 1;
            this.addToCartEvent();
        },
        removeFromCart() {
            this.removeFromCartEvent(this.item.quantity);
            this.$emit('remove-from-cart', this.item.id);
        },
        addToCartEvent() {
            var $item = {
                "id": this.item.id,
                "name": this.item.name,
                "quantity": 1,
                "price": this.item.price
            };

            try {
                gtag('event', 'add_to_cart', {
                    "items": [ $item ]
                });
            } catch (error) {
                console.log(error);
            };

            try {
                waitForFbq(function () {
                    fbq('track', 'AddToCart', this.fbCartItemData(this.item, 1));
                });
            } catch(err) {
                console.log(err);
            }
        },
        removeFromCartEvent(quantity) {
            try {
                gtag('event', 'remove_from_cart', {
                    "items": [{
                        "id": this.item.id,
                        "name": this.item.name,
                        "quantity": quantity,
                        "price": this.item.price
                    }]
                });
            } catch (error) {
                console.log(error);
            };

            try {
                waitForFbq(function () {
                    fbq('track', 'RemoveFromCart', this.fbCartItemData(this.item, quantity));
                });
            } catch(err) {
                console.log(err);
            }
        }
    },
    watch: {
        cartItemQuantity: function (quantity) {
            this.$emit("change-item-quantity", this.item.id, quantity);
        }
    }
};
</script>
